import { ValueLegend } from "src/components/ValueLegend/ValueLegend";
import { ValueChart } from "src/components/__pageComponents/PnlPage/components/IValueChartProps";
import {
  useGlobalCurrency,
  usePerformance,
  useReportBespoke,
  useSnapshot,
  useStructureGrouping,
} from "@iliotech/data-wire";
import { useGlobalPeriod } from "@iliotech/data-wire";
import { useReportContext } from "@iliotech/data-wire";
import { useProfitHistory } from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { useSnapshotLegendItems } from "../../__shared/useSnapshotLegendItems";
import * as React from "react";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const NetWorthVsInvestmentWidget = ({
  height,
  width,
  isHalfHeight,
  structureContext,
  periodContext,
}: ReportWidgetProps) => {
  const { portfolioId } = useParams();
  const profitHistory = useProfitHistory(portfolioId!);
  const store = useReportBespoke();
  const generating = store.generating;
  const { currencyFormatter } = useGlobalCurrency();
  const snapshots = useSnapshot(portfolioId!, periodContext?.period);
  const { periodDays, period, periodString } = periodContext;
  const pnlPerformance = usePerformance(
    portfolioId!,
    periodContext?.periodForRequest
  );
  const { getLegendItems } = useSnapshotLegendItems({
    grouping: structureContext?.grouping,
    currencyFormatter,
    snapshots: snapshots?.data?.data ?? [],
    t: () => "",
  });

  const allPositionLegendItems = getLegendItems(false);

  const memoizedValueChart = React.useMemo(
    () =>
      !profitHistory?.isLoading && (
        <ValueChart
          generating={generating}
          periodDays={periodDays}
          pnlPerformance={pnlPerformance?.data?.data}
          currencyFormatter={currencyFormatter}
          period={period}
          height={height}
          width={width}
        />
      ),
    [
      profitHistory?.isLoading,
      generating,
      periodDays,
      pnlPerformance?.data?.data,
      currencyFormatter,
      period,
      height,
      width,
    ]
  );

  return (
    <div>
      <h4 className={"element-title"}>Net Worth vs Investment</h4>
      <p className={"period-string"}>{periodString}</p>
      {memoizedValueChart}
      <ValueLegend small={isHalfHeight} items={allPositionLegendItems} />
    </div>
  );
};
